import { render, staticRenderFns } from "./lensAssessment.vue?vue&type=template&id=0f2ea33c&scoped=true&"
import script from "./lensAssessment.vue?vue&type=script&lang=js&"
export * from "./lensAssessment.vue?vue&type=script&lang=js&"
import style0 from "./lensAssessment.vue?vue&type=style&index=0&id=0f2ea33c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2ea33c",
  null
  
)

export default component.exports